import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetWebpageSettingParams, WebpageSettingPageGet, WebpageSettingService } from '@app/services/webpage-setting.service';
import { from, ReplaySubject, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-webpage-setting',
    templateUrl: './webpage-setting.component.html',
    styleUrls: ['./webpage-setting.component.css'],
})
export class WebpageSettingComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public params?: GetWebpageSettingParams;

    public params$ = new ReplaySubject<GetWebpageSettingParams>(1);

    private destroy$ = new Subject<void>();

    public get?: WebpageSettingPageGet;

    public grid?: GridOptions;

    constructor(
        private webpageSetting: WebpageSettingService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.params$
            .pipe(
                takeUntil(this.destroy$),
                switchMap((params) => from(this.webpageSetting.getWebpageSettingPage(params))),
            )
            .subscribe({
                next: (value) => {
                    this.get = value;
                    this.navigator?.setHeading?.(this.get.webpage_heading);
                },
            });
    }

    public readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_webpagesetting.grid').setLoadDataFunction({ method: 4026, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async init(params: GetWebpageSettingParams) {
        this.readGrid();
        this.params$.next(params);
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.params = this.navigator.params as any;
            this.init(this.params!);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init(this.params!);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.params$.complete();
    }
}
